import Plausible from "plausible-tracker";

export default class AppAnalytics {
  private static plausible: ReturnType<typeof Plausible> | null = null;

  static getPlausible() {
    if (AppAnalytics.plausible === null) {
      const plausible = Plausible({
        domain: 'caninehealthcenter.com',
        apiHost: 'https://neostraw.caninehealthcenter.com',
        trackLocalhost: false,
      })
      plausible.enableAutoPageviews()

      AppAnalytics.plausible = plausible
    }

    return AppAnalytics.plausible
  }
}

